import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  GET_PRODUCTTYPE,
  DELETE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE,
  ADD_NEW_PRODUCTTYPE,
} from "./actionType";

import {
  getProductTypeSuccess,
  getProductTypeFail,
  deleteProductTypeSuccess,
  deleteProductTypeFail,
  updateProductTypeSuccess,
  updateProductTypeFail,
  addProductTypeSuccess,
  addProductTypeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getProductTypeApi,
  updateProductTypeApi,
  deleteProductTypeApi,
  addNewProductTypeApi,
} from "../../helpers/backend_helper";

function* getProductType({ payload: productType, path }) {
  try {
    const response = yield call(getProductTypeApi, productType, path);
    yield put(getProductTypeSuccess(GET_PRODUCTTYPE, response.data));
  } catch (error) {
    yield put(getProductTypeFail(GET_PRODUCTTYPE, error));
  }
}

function* onUpdateProductType({ payload: productType }) {
  try {
    const response = yield call(updateProductTypeApi, productType);
    yield put(updateProductTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateProductTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteProductType({ payload: productType }) {
  try {
    const response = yield call(deleteProductTypeApi, productType);
    yield put(deleteProductTypeSuccess({ productType, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteProductTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewProductType({ payload: productType }) {
  try {
    const response = yield call(addNewProductTypeApi, productType);
    yield put(addProductTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addProductTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetProductType() {
  yield takeEvery(GET_PRODUCTTYPE, getProductType);
}

export function* watchUpdateProductType() {
  yield takeEvery(UPDATE_PRODUCTTYPE, onUpdateProductType);
}

export function* watchDeleteProductType() {
  yield takeEvery(DELETE_PRODUCTTYPE, onDeleteProductType);
}

export function* watchAddNewProductType() {
  yield takeEvery(ADD_NEW_PRODUCTTYPE, onAddNewProductType);
}

function* productTypeSaga() {
  yield all([
    fork(watchGetProductType),
    fork(watchDeleteProductType),
    fork(watchUpdateProductType),
    fork(watchAddNewProductType),
  ]);
}

export default productTypeSaga;
